var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownload = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62772 8.23414L8.40763 12.7202C8.55312 12.8973 8.77086 13 9.00075 13C9.23065 13 9.44839 12.8973 9.59388 12.7202L13.3738 8.23414C13.5794 7.99486 13.6298 7.65988 13.5036 7.3712C13.3775 7.08252 13.0968 6.89072 12.7807 6.87711H11.2898L11.2898 1L6.72074 1L6.72074 6.87711L5.22587 6.87711C4.90881 6.8889 4.62646 7.08001 4.49906 7.36906C4.37165 7.6581 4.42163 7.99417 4.62772 8.23414Z",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_16_2",
    d: "M0.999999 13V17L17 17L17 13",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download.8edb2e4a.svg";
export { ForwardRef as ReactComponent };